import { namespace as createVuexClass } from 'vuex-class';

import { Filters, Suggestions, V2Device } from 'ctp-search-device';

export const namespace = 'devices';
export const store = createVuexClass(namespace);

export const UPDATE_DEVICES_LIST_STATE = 'updateDevicesListState';
export const QUERY_NUMBER_OF_ACTIVE_DEVICES = 'queryNumberOfActiveDevices';
export const QUERY_DEVICES_LAST_POSITIONS = 'queryDevicesLastPositions';
export const SEARCH_DEVICES = 'searchDevices';
export const DEVICES_LIST_NAVIGATION = 'devicesListNavigation';
export const USER_SELECTION_REGISTER_DEVICE = 'userSelectionRegisterDevice';
export const USER_SELECTION_CLEAR_DEVICES = 'userSelectionClearDevices';
export const USER_SELECTION_RESET_ACTIONS = 'userSelectionResetActions';
export const TRIGGER_DEVICE_USER_SELECTION_ACTION = 'triggerDeviceUserSelectionAction';
export const UPDATE_NAVIGATION = 'updateNavigation';
export const REINIT = 'reinit';
export const REQUEST_CHANGE_DEVICE_STATE_OBU = 'changeDevicesStateObu';
export const REQUEST_CHANGE_DEVICE_STATE_VDO = 'changeDevicesStateVdo';
export const FETCH_SUGGESTIONS = 'fetchSuggestions';
export const QUERY_DEVICES_HISTORY = 'queryDevicesHistory';
export const QUERY_DEVICES_TOLL_DOMAINS_NAMES = 'queryDevicesTollDomainsNames';
export const SAVE_DEVICE_FILTERS = 'saveDeviceFilters';

export interface IDevicesState {
  [view: string]: any;
}

export interface IDevicesStatePayload {
  stateKey: string;
  view: string;
  stateValue: any;
}

export interface IDevicesListState {
  [state: string]: IDevicesState;
}

export interface INavigation {
  start: number;
  devicesPerPage: number;
  direction: 'backward' | 'forward';
  isLastDevicePage: boolean;
  filters?: Filters;
}

export interface ITollDomainName {
  id: number;
  name: string;
  type: number;
  namedRules: string[];
}

export interface IDeviceTollDomains {
  deviceID: string,
  tollDomains: ITollDomainName[],
}

export interface IDevice {
  devicesList: V2Device[];
  devicesHistory: any[];
  numberOfActiveDevices: number;
  devicesTollDomainsList: any[];
  devicesTollDomainsNames: IDeviceTollDomains[];
  navigation: INavigation;
  total: number;
}

export interface IDeviceActions {
  label: string;
  enabled: boolean;
}

export interface IUserSelection {
  devices: string[];
  actions: {
    [key: string]: IDeviceActions;
  };
}

export interface ISavedFilters {
  selectedFilters: string[],
  multiSearch: string
}

export interface DevicesState {
  devicesListComponentsState: IDevicesListState;
  devices: IDevice;
  userSelection: IUserSelection;
  suggestions?: Suggestions;
  savedFilters?: ISavedFilters
}

export enum TollingState {
  Active = 'active',
  Ban = 'ban',
  Lock = 'lock',
  Transport = 'transport',
  Unpersonalised = 'unpersonalised',
  Failure = 'devicefailure',
  Sleep = 'sleep',
  Disabled = 'disabled',
  Parked = 'parked'
}

export enum TollingStateReason {
  FraudSuspicion = 'fraudSuspicion',
  PaymentDefault = 'paymentDefault',
  DeviceLost = 'deviceLost',
}
